export const isPasswordValid = (value: string) => validatePasswordConditionSeparatly(value).allConditions;

export const passwordRules = [
  {
    key: 'lowercase',
    rule: (value: string) => /[a-z]/.test(value),
    title: 'Lowercase letter',
  },
  {
    key: 'number',
    rule: (value: string) => /\d/.test(value),
    title: 'Number',
  },
  {
    key: 'longEnough',
    rule: (value: string) => value.length >= 12 && value.length <= 72,
    title: 'At least 12 characters',
  },
  {
    key: 'uppercase',
    rule: (value: string) => /[A-Z]/.test(value),
    title: 'Uppercase letter',
  },
  {
    key: 'special',
    rule: (value: string) => /[^\da-z ]/i.test(value),
    title: 'Symbol: @#$%^&* etc.',
  },
] as const;

export const validatePasswordConditionSeparatly = (value: string) => {
  const results = { longEnough: false, lowercase: false, number: false, special: false, uppercase: false };

  for (const rule of passwordRules) {
    results[rule.key] = rule.rule(value);
  }

  const numberOfFullfilledConditions = Object.values(results).filter(Boolean).length;

  return {
    ...results,
    allConditions: numberOfFullfilledConditions === passwordRules.length,
    anyCondition: numberOfFullfilledConditions > 0,
    numberOfFullfilledConditions,
  };
};
